import React, { FC } from 'react';

import * as S from './PlainIcon.styles';

interface DirectionalIconProps {
  mostRecent?: boolean;
  translateX?: number;
  translateY?: number;
  direction: string;
}

export const PlainIcon: FC<DirectionalIconProps> = ({
  mostRecent = false,
  translateX = 0,
  translateY = 0,
  direction,
}) => {
  return (
    <g transform={`translate(${translateX}, ${translateY})`}>
      <g data-testid={`plain-icon-wrapper${mostRecent ? '-last' : ''}`}>
        {!mostRecent ? (
          <S.CircleIcon direction={direction} />
        ) : (
          <>
            <S.CircleIcon direction={direction} />
            <S.CircleRingIcon direction={direction} />
          </>
        )}
      </g>
    </g>
  );
};
